import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import {
  Dialog,
  OutlinedInput,
  Typography,
  Stack,
  Box,
  DialogTitle,
  IconButton,
} from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import ApiService from "../../services/api-service";
import Loader from "./../../components/Loader";
import notifier from "./../../components/Notifier";
import { getErrorString } from "../../constants/function";
import "./index.scss";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function SellPopup(props) {
  const { t } = useTranslation("common");
  const [isLoading, setIsLoading] = useState(false);
  const [fraction, setFraction] = useState();
  const [fractions, setFractions] = useState({});
  const [nfts, setNfts] = React.useState(props["nftCount"]);
  const [loading, setLoading] = React.useState(false);
  const [amount, setAmount] = React.useState("");
  //bid
  const bid = async () => {
    try {
      const payload = {
        sellingPrice: amount,
        type: props["type"] ? props["type"] : "playlist",
      };
      if (props["type"] && props["type"] === "music") {
        payload["assetId"] = props["assetId"];
        payload["rank"] = fraction;
      } else {
        payload["assetId"] = props["assetId"];
        payload["rank"] = 1;
      }
      setLoading(true);
      const response = await ApiService.SELL_NFT_V2(payload);

      setLoading(false);
      notifier.success(response["result"]);
      props.handleClose({ amount: amount });
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };

  const getNftFractions = async (assetId) => {
    try {
      setFractions({});
      setIsLoading(true);
      const response = await ApiService.GET_NFT_FRACTIONS(
        `${assetId}&onSale=false`
      );
      setFractions({ ...response["result"] });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  React.useEffect(() => {
    if (props["type"] === "music" && props["isMaster"])
      getNftFractions(props["assetId"]);
    else if (props["type"] === "fraction" && props["isMaster"]) {
      const fr = { fractions: props.fractions };
      setFractions({ ...fr });
    } else setFraction(props["rank"]);
  }, []);
  const handleSelect = (fr, i) => {
    if (props.showOnly) {
    } else setFraction(fr == fraction ? null : fr);
  };
  return (
    <div>
      <Dialog
        open={props.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={props.handleClose}
        PaperProps={{
          style: {
            position: "relative",
            // backgroundColor: "#1A1A1A",
            backgroundColor: "#171515",
            boxShadow: "none",
            color: "#000000",
            borderRadius: 16,
            paddingBottom: "16px",
            // width: "50%",
            backgroundImage: "none",
          },
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <Stack spacing={1}>
          <DialogTitle
            color="default"
            sx={{
              padding: "16px",
              color: "#ffffff",
              fontSize: "20px",
              borderBottom: "1px solid #1E1E1E",
            }}
          >
            {t("nftFraction")}
            <IconButton
              aria-label="close"
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
              }}
              onClick={() => props.handleClose(false)}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ padding: "16px" }}>
            {
              props["type"] === "playlist" ? null : props["isMaster"] ? (
                <Box className="__sell_nft_fractions">
                  <Stack
                    direction="row"
                    justifyContent="flex-start"
                    spacing={1}
                  >
                    <Typography className="fs-18">
                      {t("sellPopup.title")} :
                    </Typography>
                    {props.showOnly ? (
                      <Typography className="fs-18 success">
                        {props?.fractions.length}
                      </Typography>
                    ) : (
                      <Typography className="fs-17">
                        {fractions["availableFractions"] || 0}/
                        {fractions["totalFractions"] || 0}
                      </Typography>
                    )}
                  </Stack>
                  <Stack
                    className="_nft_fractions_box"
                    sx={{ maxHeight: "80% !important" }}
                  >
                    {fractions["fractions"] &&
                      fractions["fractions"].map((f, index) => (
                        <Typography
                          onClick={() => handleSelect(f, index)}
                          className={
                            "_fraction " +
                            (fraction === f ? "_fraction_selected" : "")
                          }
                          key={index}
                        >
                          {f}
                        </Typography>
                      ))}
                  </Stack>
                  {isLoading ? (
                    <Loader _class="__loader_inside" wait="true" />
                  ) : null}
                </Box>
              ) : null
              // <>
              //   <Stack spacing={1}>
              //     <Typography className="fs-14" color="default">
              //       Number of NFTs to Sell
              //     </Typography>
              //     <OutlinedInput
              //       sx={{ height: "50px !important" }}
              //       type="number"
              //       autoFocus
              //       margin="dense"
              //       id="name"
              //       value={nfts}
              //       onChange={(e) => {
              //         setNfts(e.target.value);
              //       }}
              //       placeholder="0"
              //       endAdornment={
              //         <Typography
              //           sx={{
              //             color: "#FFFFFF50 !important",
              //             padding: "5px",
              //             fontSize: "12px !important",
              //           }}
              //         >
              //           NFTs
              //         </Typography>
              //       }
              //     />
              //   </Stack>
              //   {nfts && nfts > props["nftCount"] ? (
              //     <Typography className="fs-12" color="error">
              //       Nft count should not be more than {props["nftCount"]}
              //     </Typography>
              //   ) : null}
              // </>
            }
            {props.showOnly ? null : (
              <Box sx={{ overflow: "hidden" }}>
                <Typography className="fs-14">
                  {t("sellPopup.label")}
                </Typography>
                <OutlinedInput
                  sx={{
                    width: "100%",
                    height: "50px !important",
                    marginTop: "5px",
                  }}
                  type="number"
                  autoFocus
                  margin="dense"
                  id="name"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  onKeyDown={(e) =>
                    ["e", "E", "+", "-", "."].includes(e.key) &&
                    e.preventDefault()
                  }
                  placeholder={t("sellPopup.placeholder")}
                  autoComplete="off"
                  endAdornment={
                    <Typography
                      sx={{
                        color: "#FFFFFF50 !important",
                        padding: "5px",
                        fontSize: "12px !important",
                      }}
                    >
                      SIKI Coins
                    </Typography>
                  }
                />
              </Box>
            )}
          </DialogContent>
          {props.showOnly ? null : (
            <DialogActions sx={{ justifyContent: "space-between" }}>
              <Button
                sx={{ padding: "10px 35px" }}
                color="default"
                onClick={() => props.handleClose(false)}
                className="__sell_botton"
              >
                {t("sellPopup.button1")}
              </Button>
              <Button
                sx={{ padding: "10px 35px" }}
                variant="contained"
                color="primary"
                onClick={bid}
                // disabled={!amount || !nfts || (nfts && nfts > props["nftCount"])}
                disabled={
                  props["type"] === "playlist"
                    ? !amount
                    : nfts == 0 || nfts > props["nftCount"] || !amount
                }
                className="__sell_botton"
              >
                {t("sellPopup.button2")}
              </Button>
            </DialogActions>
          )}
        </Stack>
        {loading ? <Loader wait={true} /> : null}
      </Dialog>
    </div>
  );
}
